const module = { name: 'shared/global/smoothScroll', exports: {} }; const exports = module.exports;

function run(anchor) {
    const element = document.getElementById(anchor);
    if (!element) {
        return;
    }
    element.scrollIntoView({ behavior: 'smooth' });
}
module.exports = {
    run
};
export default module.exports;